import { useApiGet } from '@sierralabs/core-ui';
export function useGetFileTreeById(id) {
    return useApiGet(`folders/tree/${id}`);
}
//# sourceMappingURL=useGetFileTreeById.js.map